import { connect } from 'react-redux';
import { pushModal } from 'src/ducks/ui/modal';

import PreventUnmount from './PreventUnmount';

const mapDispatchToProps = { pushModal };

export default connect(null, mapDispatchToProps)(PreventUnmount);
